import { replaceSubarray } from './replaceSubarray';
export const replaceSubarrayOnIndex = (oldArray, newArray, index) => replaceSubarray(oldArray, newArray, index, index + newArray.length);
//# sourceMappingURL=replaceSubarrayOnIndex.js.map